/**
 *   Установка pwa на рабочий столи или мобильный

     PwaInstall.addCallbacks({
        init: () => {...},
        before: () => {...},
        accepted: () => {...},
        dismissed: () => {...},
    });

**/

class PwaInstall {
    constructor() {
        this.deferredInstallPrompt = null;
        this.callbacks = [];

        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            // Add event listener for beforeinstallprompt event
            window.addEventListener('beforeinstallprompt', this.saveBeforeInstallPromptEvent.bind(this));

            this.callbacks.forEach((el) => el.init && el.init());
        });
    }

    saveBeforeInstallPromptEvent(e) {
        // Add code to save event & show the install button.
        this.deferredInstallPrompt = e;

        this.callbacks.forEach((el) => el.before && el.before());

        // Log user response to prompt.
        this.deferredInstallPrompt.userChoice
            .then((choice) => {
                if (choice.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt', choice);
                    this.callbacks.forEach((el) => el.accepted && el.accepted());
                } else {
                    console.log('User dismissed the A2HS prompt', choice);
                    this.callbacks.forEach((el) => el.dismissed && el.dismissed());
                }
                this.deferredInstallPrompt = null;
            });
    }

    addCallbacks(callbacks) {
        this.callbacks.push(callbacks);
    }

    install() {
        this.deferredInstallPrompt && this.deferredInstallPrompt.prompt();
    }
}

export default new PwaInstall();
